// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"6141f548","519":"967b6c45","618":"36567458","738":"fc47b667","747":"3aaaf118"}[chunkId] + ".chunk.js";
};